export default __webpack_public_path__ + "static/media/scanner.042512bf.svg";